import { Inject, Component, OnInit} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ComponentModel, ComponentTargetConfigurations } from '../../models/component.model';
import { Tenant } from '../../models/tenant.model';
import { adminService } from '../../services/admin.service';
import { GlobalService } from '../../services/global.service';
import { RefineryService } from '../../services/refinery.service';
import * as moment from 'moment';
import { AlertComponent } from '../../common/alert/alert.component';

@Component({
  selector: 'app-component-page',
  templateUrl: './component-page.component.html',
  styleUrls: ['./component-page.component.css']
})
export class ComponentPageComponent implements OnInit {

  isLoading = false;
  masterComponentList;
  tenantList: Tenant[];
  hideCheckBox = false;
  isDbCreationAllowed = false;
  dataSourceTypesList;

  public componentDetailForm = new UntypedFormGroup({
    componentId: new UntypedFormControl(),
    masterComponentId: new UntypedFormControl({ value: '', disabled: false }, Validators.required),
    tenantId: new UntypedFormControl({ value: '', disabled: false }, Validators.required),
    componentDbConnStr: new UntypedFormControl({ value: '', disabled: false }, Validators.required),
    componentDbConnStrValue: new UntypedFormControl({ value: '', disabled: false }, Validators.required),
    componentDbOdbcConnStr: new UntypedFormControl({ value: '', disabled: false }, Validators.required),
    componentDbOdbcConnStrValue: new UntypedFormControl({ value: '', disabled: false }, Validators.required),
    componentTargetConfiguration: new UntypedFormControl({ value: '', disabled: false }, Validators.required),
    targetTypeId: new UntypedFormControl({ value: '', disabled: false }, Validators.required),
    targetTableName: new UntypedFormControl({ value: '', disabled: false }, Validators.required),
    targetDbConnStr: new UntypedFormControl({ value: '', disabled: false }),
    targetDbOdbcConnStr: new UntypedFormControl({ value: '', disabled: false }),
    targetDbConnStrValue: new UntypedFormControl({ value: '', disabled: false }),
    targetDbOdbcConnStrValue: new UntypedFormControl({ value: '', disabled: false }),
    cosmosDbKey: new UntypedFormControl({ value: '', disabled: false }),
    cosmosDbKeyValue: new UntypedFormControl({ value: '', disabled: false }),
    cosmosDbApiUrl: new UntypedFormControl({ value: '', disabled: false }),
    cosmosDbApiUrlValue: new UntypedFormControl({ value: '', disabled: false }),
    cosmosDbName: new UntypedFormControl({ value: '', disabled: false })
  });

  constructor(public dialogRef: MatDialogRef<ComponentPageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, public globalService: GlobalService,
    private readonly adminservice: adminService, private readonly refineryService: RefineryService) { }

  ngOnInit(): void {
    this.isLoading = true;
    this.loadMasterComponentData();
    this.loadComponentDataPage();
    this.getDataSourceTypes();
  }

  changeComponent(event) {
    let dbCreationAllowed = event.target.selectedOptions[0].text
    this.isLoading = true;
    const tenantId = this.componentDetailForm.controls['tenantId'].value;
    const masterComponentId = this.componentDetailForm.controls['masterComponentId'].value;

    this.adminservice.getComponentSubscription(tenantId, masterComponentId).subscribe((data: any) => {
      this.isLoading = false;
      if (data == null) {
        this.isDbCreationAllowed = event.target.value ? true : false;
        this.isDbCreationAllowed = dbCreationAllowed === 'platformhub' ? false : this.isDbCreationAllowed;
        const selectedComponentId = masterComponentId;
        const componentDbConnStrValue: string = this.masterComponentList.
          find(component => component.componentId === selectedComponentId).componentDbConnStr;
        const componentDbOdbcConnStrValue: string = this.masterComponentList.
          find(component => component.componentId === selectedComponentId).componentDbOdbcConnStr;
        const componentDbConnStrSecretName: string = this.masterComponentList.
          find(component => component.componentId === selectedComponentId).componentDbConnStrSecretName;
        const componentDbOdbcConnStrSecretName: string = this.masterComponentList.
          find(component => component.componentId === selectedComponentId).componentDbOdbcConnStrSecretName;
        this.componentDetailForm.controls['componentDbConnStrValue'].setValue(componentDbConnStrValue);
        this.componentDetailForm.controls['componentDbOdbcConnStrValue'].setValue(componentDbOdbcConnStrValue);
        this.componentDetailForm.controls['componentDbConnStr'].setValue(componentDbConnStrSecretName);
        this.componentDetailForm.controls['componentDbOdbcConnStr'].setValue(componentDbOdbcConnStrSecretName);
        document.addEventListener("DOMContentLoaded", function (event) {
          (<HTMLInputElement>document.getElementById("createBtn")).disabled = false;
        });
      }
      else {
        this.componentDetailForm.controls['componentDbConnStrValue'].setValue('');
        this.componentDetailForm.controls['componentDbOdbcConnStrValue'].setValue('');
        this.componentDetailForm.controls['componentDbConnStr'].setValue('');
        this.componentDetailForm.controls['componentDbOdbcConnStr'].setValue('');
        document.addEventListener("DOMContentLoaded", function(event) {
          (<HTMLInputElement>document.getElementById("createBtn")).disabled = true;
        });
        
        this.globalService.showAlert(AlertComponent, { success: false, message: "This component is already subscribed." });
      }
    });

  }

  /**Get list of datasource types*/
  getDataSourceTypes() {
    this.adminservice.getDataSourceTypesList().subscribe((data: any): void => {
      this.dataSourceTypesList = data;
      this.isLoading = false;
    }, (error: Error) => {
      console.log('Error while fetching data source types list', error.message);
    });
  }

  loadComponentDataPage() {
    let componentTargetConfigurations = false;
    if (this.data.displayType !== 'add' && this.globalService.isNotNullObject(this.data.data)) {
      let disableMode = false;
      if (this.data.displayType === 'view') {
        disableMode = true;
      }
      if (this.data.displayType === 'edit') {
        this.isDbCreationAllowed = this.data.data.masterComponentId === 9 ? false : true;
      }
      if (this.globalService.isNotNullObject(this.data.data.componentTargetConfigurations)
        && this.data.data.componentTargetConfigurations.length !== 0) {
        componentTargetConfigurations = true;
        this.componentDetailForm = new UntypedFormGroup({
          componentId: new UntypedFormControl({ value: this.data.data.componentId, disabled: disableMode }, Validators.required),
          masterComponentId: new UntypedFormControl({ value: this.data.data.masterComponentId, disabled: disableMode }, Validators.required),
          tenantId: new UntypedFormControl({ value: this.data.data.tenantId, disabled: disableMode }, Validators.required),
          componentDbConnStr: new UntypedFormControl({ value: this.data.data.componentDbConnStr, disabled: disableMode }, Validators.required),
          componentDbConnStrValue: new UntypedFormControl({ value: this.data.data.componentDbConnStrValue, disabled: disableMode }, Validators.required),
          componentDbOdbcConnStr: new UntypedFormControl({ value: this.data.data.componentDbOdbcConnStr, disabled: disableMode }, Validators.required),
          cosmosDbKey: new UntypedFormControl({
            value: this.data.data.componentTargetConfigurations[0].cosmosDbKey, disabled: disableMode
          }),
          cosmosDbKeyValue: new UntypedFormControl({
            value: this.data.data.componentTargetConfigurations[0].cosmosDbKeyValue, disabled: disableMode
          }),
          cosmosDbApiUrl: new UntypedFormControl({
            value: this.data.data.componentTargetConfigurations[0].cosmosDbApiUrl, disabled: disableMode
          }),
          cosmosDbApiUrlValue: new UntypedFormControl({
            value: this.data.data.componentTargetConfigurations[0].cosmosDbApiUrlValue, disabled: disableMode
          }),
          cosmosDbName: new UntypedFormControl({
            value: this.data.data.componentTargetConfigurations[0].cosmosDbName, disabled: disableMode
          }),
          componentDbOdbcConnStrValue: new UntypedFormControl({ value: this.data.data.componentDbOdbcConnStrValue, disabled: disableMode }, Validators.required),
          componentTargetConfiguration: new UntypedFormControl({ value: componentTargetConfigurations, disabled: disableMode }, Validators.required),
          targetTypeId: new UntypedFormControl({
            value: this.data.data.componentTargetConfigurations[0].targetTypeId,
            disabled: disableMode
          }, Validators.required),
          targetTableName: new UntypedFormControl({
            value: this.data.data.componentTargetConfigurations[0].targetTableName,
            disabled: disableMode
          }, Validators.required),
          targetDbConnStr: new UntypedFormControl({
            value: this.data.data.componentTargetConfigurations[0].targetDbConnStr, disabled: disableMode
          }),
          targetDbOdbcConnStr: new UntypedFormControl({
            value: this.data.data.componentTargetConfigurations[0].targetDbOdbcConnStr, disabled: disableMode
          }),
          targetDbConnStrValue: new UntypedFormControl({
            value: this.data.data.componentTargetConfigurations[0].targetDbConnStrValue, disabled: disableMode
          }),
          targetDbOdbcConnStrValue: new UntypedFormControl({
            value: this.data.data.componentTargetConfigurations[0].targetDbOdbcConnStrValue, disabled: disableMode
          })
        });
      } else {
        this.componentDetailForm = new UntypedFormGroup({
          componentId: new UntypedFormControl({ value: this.data.data.componentId, disabled: disableMode }, Validators.required),
          masterComponentId: new UntypedFormControl({ value: this.data.data.masterComponentId, disabled: disableMode }, Validators.required),
          tenantId: new UntypedFormControl({ value: this.data.data.tenantId, disabled: disableMode }, Validators.required),
          componentDbConnStr: new UntypedFormControl({ value: this.data.data.componentDbConnStr, disabled: disableMode }, Validators.required),
          componentDbConnStrValue: new UntypedFormControl({ value: this.data.data.componentDbConnStrValue, disabled: disableMode }, Validators.required),
          componentDbOdbcConnStr: new UntypedFormControl({ value: this.data.data.componentDbOdbcConnStr, disabled: disableMode }, Validators.required),
          cosmosDbKey: new UntypedFormControl({ value: '', disabled: disableMode }),
          cosmosDbKeyValue: new UntypedFormControl({ value: '', disabled: disableMode }),
          cosmosDbApiUrl: new UntypedFormControl({ value: '', disabled: disableMode }),
          cosmosDbApiUrlValue: new UntypedFormControl({ value: '', disabled: disableMode }),
          cosmosDbName: new UntypedFormControl({ value: '', disabled: disableMode }),
          componentDbOdbcConnStrValue: new UntypedFormControl({
            value: this.data.data.componentDbOdbcConnStrValue,
            disabled: disableMode
          }, Validators.required),
          componentTargetConfiguration: new UntypedFormControl({ value: componentTargetConfigurations, disabled: disableMode }, Validators.required),
          targetTypeId: new UntypedFormControl({ value: '', disabled: disableMode }, Validators.required),
          targetTableName: new UntypedFormControl({ value: '', disabled: disableMode }, Validators.required),
          targetDbConnStr: new UntypedFormControl({ value: '', disabled: disableMode }),
          targetDbOdbcConnStr: new UntypedFormControl({ value: '', disabled: disableMode }),
          targetDbConnStrValue: new UntypedFormControl({ value: '', disabled: disableMode }),
          targetDbOdbcConnStrValue: new UntypedFormControl({ value: '', disabled: disableMode })
        });
      }
      this.isLoading = false;
    } else {
      this.isLoading = false;
    }
  }

  /**Load master component data*/
  loadMasterComponentData() {
    this.adminservice.fetchMasterComponentList().subscribe((data: any): void => {
      this.masterComponentList = data;
      this.loadTenantList();
    }, (error: Error) => {
      console.log('Error while fetching master component list', error.message);
    });
  }

  /**Load Tenant List data for selected refinery*/
  loadTenantList() {
    this.adminservice.getTenantList(this.refineryService.currentRefinery.refineryId).subscribe((data: any): void => {
      this.tenantList = data;
      this.isLoading = false;
    }, (error: Error) => {
      console.log('Error while fetching tenant list', error.message);
    });
  }

  /**Check if target data shouldbe displayed */
  displayTargetData() {
    let check = false;
    if (this.data.displayType === 'view' && this.data?.data.componentTargetConfigurations.length !== 0) {
      check = true;
    } else if (this.data.displayType === 'view' && this.data.data.componentTargetConfigurations.length <= 0) {
      check = this.componentDetailForm.get('componentTargetConfiguration').value;
      this.hideCheckBox = true;
    } else {
      check = this.componentDetailForm.get('componentTargetConfiguration').value;
    }
    return check;
  }

  saveComponent() {    
    console.log(this.componentDetailForm);
    const componentData: ComponentModel = this.componentDetailForm.value;
    if (this.globalService.isNotNullObject(componentData.masterComponentId)) {
      componentData.componentName = this.masterComponentList.find((item: any) =>
        item.componentId === componentData.masterComponentId).componentName;
      componentData.tenantName = this.tenantList.find((item: any) => item.tenantId === componentData.tenantId).tenantName;
    }
    if (this.data.displayType === 'add') {
      componentData.componentId = 0;
      componentData.createdBy = this.globalService.loggedInUser;
      componentData.createdTime = moment.utc(new Date()).local().format('YYYY-MM-DDTHH:mm:ss');
    }
    componentData.lastModifiedBy = this.globalService.loggedInUser;
    componentData.lastModifiedTime = moment.utc(new Date()).local().format('YYYY-MM-DDTHH:mm:ss');
    if (this.componentDetailForm.get('componentTargetConfiguration').value) {
      const componentTargetConfigurationsData = new ComponentTargetConfigurations();
      componentTargetConfigurationsData.id = 0;
      componentTargetConfigurationsData.targetTypeId = this.componentDetailForm.get('targetTypeId').value;
      componentTargetConfigurationsData.tenantId = this.componentDetailForm.get('tenantId').value;
      componentTargetConfigurationsData.componentId = componentData.componentId;
      componentTargetConfigurationsData.targetTableName = this.componentDetailForm.get('targetTableName').value;
      componentTargetConfigurationsData.targetDbConnStr = this.componentDetailForm.get('targetDbConnStr').value;
      componentTargetConfigurationsData.targetDbConnStrValue = this.componentDetailForm.get('targetDbConnStrValue').value;
      componentTargetConfigurationsData.targetDbOdbcConnStr = this.componentDetailForm.get('targetDbOdbcConnStr').value;
      componentTargetConfigurationsData.targetDbOdbcConnStrValue = this.componentDetailForm.get('targetDbOdbcConnStrValue').value;
      componentTargetConfigurationsData.cosmosDbKey = this.componentDetailForm.get('cosmosDbKey').value;
      componentTargetConfigurationsData.cosmosDbApiUrl = this.componentDetailForm.get('cosmosDbApiUrl').value;
      componentTargetConfigurationsData.cosmosDbApiUrlValue = this.componentDetailForm.get('cosmosDbApiUrlValue').value;
      componentTargetConfigurationsData.cosmosDbKeyValue = this.componentDetailForm.get('cosmosDbKeyValue').value;
      componentTargetConfigurationsData.cosmosDbName = this.componentDetailForm.get('cosmosDbName').value;
      componentData.componentTargetConfigurations = [componentTargetConfigurationsData];
    }
    this.adminservice.saveComponent(componentData, this.data.displayType).subscribe((data: any): void => {
      this.globalService.showAlert(AlertComponent, { success: true, message: 'Component ' + componentData.componentName + ' saved successfully.' });
      this.onCancelClick(true);
    }, (error: Error) => {
      this.isLoading = false;
      this.globalService.showAlert(AlertComponent, { success: false, message: 'Component ' + componentData.componentName + ' could not be saved.' });
    });
  }


  /**
   * sets connection strings of created azure sql db to appropriate fields
   * @param thisref context reference
   * @param result result of creation
   */
  setConnStrings(thisref, result) {
    const selectedComponentId = thisref.componentDetailForm.controls['masterComponentId'].value;
    let componentDbConnStrValue: string = thisref.masterComponentList.
      find(component => component.componentId === selectedComponentId).componentDbConnStr;
    let componentDbOdbcConnStrValue: string = thisref.masterComponentList.
      find(component => component.componentId === selectedComponentId).componentDbOdbcConnStr;
    componentDbConnStrValue = componentDbConnStrValue.replace(/{{([^{}]+)}}/g, result);
    componentDbOdbcConnStrValue = componentDbOdbcConnStrValue.replace(/{{([^{}]+)}}/g, result);
    thisref.componentDetailForm.controls['componentDbConnStrValue'].setValue(componentDbConnStrValue);
    thisref.componentDetailForm.controls['componentDbOdbcConnStrValue'].setValue(componentDbOdbcConnStrValue);
  }

  disableSave() {

    const datasourceTypeName = this.componentDetailForm.get('targetTypeId').value;

    if (datasourceTypeName == '1') {

      this.componentDetailForm.get('cosmosDbKey').clearValidators();
      this.componentDetailForm.get('cosmosDbKeyValue').clearValidators();
      this.componentDetailForm.get('cosmosDbApiUrl').clearValidators();
      this.componentDetailForm.get('cosmosDbApiUrlValue').clearValidators();
      this.componentDetailForm.get('cosmosDbName').clearValidators();
      this.componentDetailForm.get('targetDbConnStr').setValidators([Validators.required]);
      this.componentDetailForm.get('targetDbConnStrValue').setValidators([Validators.required]);
      this.componentDetailForm.get('targetDbOdbcConnStr').setValidators([Validators.required]);
      this.componentDetailForm.get('targetDbOdbcConnStrValue').setValidators([Validators.required]);
    }
    else if (datasourceTypeName == '2') {
      this.componentDetailForm.get('targetDbConnStr').clearValidators();
      this.componentDetailForm.get('targetDbConnStrValue').clearValidators();
      this.componentDetailForm.get('targetDbOdbcConnStr').clearValidators();
      this.componentDetailForm.get('targetDbOdbcConnStrValue').clearValidators();
      this.componentDetailForm.get('cosmosDbKey').setValidators([Validators.required]);
      this.componentDetailForm.get('cosmosDbKeyValue').setValidators([Validators.required]);
      this.componentDetailForm.get('cosmosDbApiUrl').setValidators([Validators.required]);
      this.componentDetailForm.get('cosmosDbApiUrlValue').setValidators([Validators.required]);
      this.componentDetailForm.get('cosmosDbName').setValidators([Validators.required]);
    }
    let check: boolean;
    if (this.componentDetailForm.get('componentTargetConfiguration').value) {
      check = !this.componentDetailForm.valid;
    } else {
      check = false;
    }
    return check;
  }

  /**Cancels the pop-up */
  onCancelClick(value: boolean): void {
    this.dialogRef.close(value);
  }

}
